import axios from "../axios-auth";

export const warehouseService = {
    getWarehouseList,
    saveWarehouse,
    getWarehouseDetail,
    getWarehousesByStatus,
    getAllWarehouse
};

function getWarehousesByStatus(status) {
    return axios.get("/auth/warehouses-by-status/" + status);
}

function getAllWarehouse() {
    return axios.get("/auth/all-warehouse");
}

function getWarehouseList(searchParams, page, size, sortedBy) {
    if (!page) {
        page = 0;
    }
    else {
        page -= 1;
    }
    if (!size) {
        size = 50;
    }

    let params = {
        page: page,
        size: size,
        sort: sortedBy
    };

    if (searchParams.name) {
        params["name"] = searchParams.name;
    }
    if (searchParams.code) {
        params["code"] = searchParams.code;
    }
    if (searchParams.status) {
        params["status"] = searchParams.status;
    }
    if (searchParams.type) {
        params["type"] = searchParams.type;
    }
    return axios.get("/auth/warehouses", { params });
}

function saveWarehouse(warehouse) {
    if (!warehouse.id) {
        // new warehouse
        return axios.post("/auth/warehouse", warehouse);
    } else {
        // edit
        return axios.put("/auth/warehouse", warehouse);
    }
}

function getWarehouseDetail(id) {
    return axios.get("/auth/warehouse/" + id);
}